export function toggleClass(
  dom: HTMLElement | null | Element,
  className: string
) {
  if (!dom) return;
  if (dom.classList.contains(className)) {
    dom.classList.remove(className);
  } else {
    dom.classList.add(className);
  }
}

export function toggleBodyFixed() {
  const isHidden = document.body.style.overflow === "hidden";
  document.body.style.overflow = isHidden ? "" : "hidden";
}
